const getInnerId = (id: string): string => {
  const sepIndex = id.lastIndexOf("-");
  return sepIndex !== -1 ? id.substring(sepIndex + 1) : id;
};

export const createPendingId = (timestamp: number): string => {
  return `pending-${timestamp}`;
};

export const createUndeliveredId = (messageId: string): string => {
  return `undelivered-${getInnerId(messageId)}`;
};
